import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'

import ParentActivationPaymentModule from '../payment'

const initialState = {
  paymentData: {},
  paymentTypeInput: {
    paymentType: null
  }
}

const ActivationPaymentModule = {
  namespaced: true,
  state: initialState,
  getters: {
    getPayment: (state, getters, rootState, rootGetters) => {
      if (rootGetters['activation/topUp/hasTopUp']) {
        return ParentActivationPaymentModule.getters.getPayment(state)
      }
      return null
    },
    paymentContext: ParentActivationPaymentModule.getters.paymentContext,
    payment: ParentActivationPaymentModule.getters.payment
  },
  actions: {
    /*
     * Modified validate Payment: we also perform activation initiate at the end, when the next step is summary
     */
    async validateAndSavePayment ({ commit, dispatch, state, getters, rootGetters }, { payment, nextStep }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      delete payment.paymentConfirmation
      delete payment.__typename
      delete payment.bin
      return apolloClient.mutate({
        mutation: gql`mutation activation ($validatePaymentInput: ValidatePaymentInput!) {
          validatePayment (validatePayment: $validatePaymentInput){
            success
          }
        }`,
        variables: {
          validatePaymentInput: {
            ...rootGetters['activation/personalData/validateAddressCore'],
            address: rootGetters['activation/personalData/address'],
            paymentType: payment
          }
        }
      }).then((response) => {
        if (response.data.validatePayment.success) {
          commit('storePaymentData', payment)
          commit('storeBankAccountOwner', getters.paymentContext)
          return dispatch('activation/submit/activationInitiate', { nextStep: nextStep }, { root: true })
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    storePaymentData: ParentActivationPaymentModule.mutations.storePaymentData,
    storeBankAccountOwner: ParentActivationPaymentModule.mutations.storeBankAccountOwner
  }
}

export default ActivationPaymentModule
